import React from "react";

const ViewIcon = () => {
  return <span className="icon-icon_chat" />;
};

export default ViewIcon;
